module.exports = __webpack_public_path__ + "img/service2-00.aba2d26d.png";